import { useState } from 'react';
export const useInputText = input => {
  const [hasFocus, setHasFocus] = useState(false);
  const handleFocus = e => {
    setHasFocus(true);
    if (input?.onFocus) {
      input.onFocus(e);
    }
  };
  const handleBlur = e => {
    setHasFocus(false);
    if (input?.onBlur) {
      input.onBlur(e);
    }
  };
  return {
    hasFocus,
    onFocus: handleFocus,
    onBlur: handleBlur
  };
};